import { mapGetters, mapActions } from 'vuex';
import store from './store';
import typeMapping from './typeMapping';

const getterList = typeMapping.map(type => `operatorOptionList${type.value}`);
const actionsList = typeMapping.map(type => `fetchOperatorList${type.value}`);

export default {
  props: {
    accessType: {
      type: Number,
      default: 0, // 0 全部 1 权限
    },
  },
  created() {
    store.install(this.$store);
  },
  mounted() {
    if (
      this[`operatorOptionList${this.accessType}`] &&
      !this[`operatorOptionList${this.accessType}`].length
    ) {
      this[`fetchOperatorList${this.accessType}`]();
    }
  },
  computed: {
    ...mapGetters('OperatoerOption', getterList),
  },
  methods: {
    ...mapActions('OperatoerOption', actionsList),
    getOperatorName(id) {
      let item = this[`operatorOptionList${this.accessType}`].find(
        ServiceType => ServiceType.id === id
      );
      if (item) {
        return item.operateName;
      } else {
        return '';
      }
    },
  },
};
